<div class="grid">
    <div class="col-12">
        <div class="card" *ngIf="exibirSpinnerPrincipal">
            <div class="flex justify-content-center">
                <p-progressSpinner></p-progressSpinner>
            </div>
        </div>
        <div class="flex flex-column md:flex-row gap-5" style="min-height: 87vh">

            <div class="flex-1 card" *ngIf="!exibirSpinnerPrincipal">
                <div class="flex flex-column h-full" *ngIf="chamadoSelecionado">

                    <div class="flex flex-wrap  align-items-center border-bottom-1 surface-border pb-4">
                        <div class="flex flex-row">
                            <div class="relative flex align-items-center mr-3">
                                <img src="assets/demo/images/avatar/avatar_suporte_4.jpeg" alt="user.name"
                                    class="w-4rem h-4rem border-circle shadow-4">
                                <span
                                    class="w-1rem h-1rem border-circle border-2 surface-border absolute bottom-0 right-0"
                                    [ngClass]="{'bg-green-400': chamadoSelecionado.status === 'ABERTO',
                                                 'bg-red-400': chamadoSelecionado.status === 'FECHADO'}">
                                </span>
                            </div>
                            <div class="flex flex-column mr-2">
                                <div class="flex flex-row">
                                    <span class="text-900 font-semibold block mr-1">
                                        {{chamadoSelecionado.protocolo}}

                                    </span>
                                    <span class="text-900 block"> - {{chamadoSelecionado.statusFormatado}}</span>

                                </div>
                                <span
                                    class="text-900 font-semibold block">{{chamadoSelecionado.empresa?.nomeFantasia}}</span>
                                <span class="text-700">{{ chamadoSelecionado.dataCriacao | date: 'dd/MM/yyyy HH:mm:ss '
                                    }}</span>
                                <span class="text-700 hover:text-primary cursor-pointer"
                                    (click)="abrirDialogDetalheChamado()">Ver mais detalhes</span>
                            </div>
                        </div>
                        <div class="flex flex-column h-full ml-auto">
                            <button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
                                class="p-button-outlined w-9rem" routerLink="/rfarias/suporte"></button>
                            <button *ngIf="exibirBotaoEncerrar" type="button" pButton icon="pi pi-power-off"
                                label="Encerrar" class="p-button-primary w-9rem mt-1"
                                (click)="encerrarChamado()"></button>
                        </div>
                    </div>

                    <div class="p-3 md:px-4 lg:px-6 lg:py-4 mt-2 overflow-y-auto" style="max-height: 53vh;" #chatWindow>

                        <div *ngFor="let message of listaMensagensChamado">

                            <div *ngIf="message.usuario?.tipo === 'EMPRESA'" class="grid grid-nogutter mb-4">
                                <div class="mr-3 mt-1">
                                    <img src="assets/demo/images/avatar/avatar-suporte.jpeg" alt="message.usuario.nome"
                                        class="w-3rem h-3rem border-circle shadow-4">
                                </div>
                                <div class="col mt-3">
                                    <p class="text-900 font-semibold mb-3">{{message.usuario?.nome}}</p>

                                    <span *ngIf="message.tipoMensagem === 'TEXTO'"
                                        class="inline-block text-left font-medium border-1 surface-border text-primary-900 p-3 white-space-normal border-round"
                                        style="word-break: break-word; max-width:80%;">
                                        {{message.conteudo}}
                                    </span>

                                    <span *ngIf="message.tipoMensagem === 'IMAGEM'" class="cursor-pointer">
                                        <img class="w-12rem h-10rem" [src]="message.conteudo" alt=""
                                            (click)="baixarArquivoUrl(message.conteudo)">
                                    </span>

                                    <span *ngIf="message.tipoMensagem !== 'TEXTO' && message.tipoMensagem !== 'IMAGEM'"
                                        class="inline-block text-left font-medium border-1 surface-border text-primary-900
                                         p-3 white-space-normal border-round cursor-pointer hover:underline"
                                        style="word-break: break-word; max-width:80%;"
                                         (click)="baixarArquivoUrl(message.conteudo)" [pTooltip]="message.nomeArquivo ?? ''">
                                        <i [ngClass]="obterIconeArquivo(message.tipoMensagem)"
                                            class="mr-1"></i>{{message.nomeArquivo | slice:0:20}}
                                    </span>

                                    <p class="text-700 mt-3">{{ message.dataCriacao | date:'dd/MM/yyy HH:mm:ss' }} <i
                                            class="pi pi-check ml-2 text-green-400"></i></p>
                                </div>
                            </div>

                            <div *ngIf="message.usuario?.tipo === 'FRANQUIA'" class="grid grid-nogutter mb-4">

                                <div class="col mt-3 text-right">
                                    <p class="text-900 font-semibold mb-3">{{message.usuario?.nome}} - SUPORTE</p>

                                    <span *ngIf="message.tipoMensagem === 'TEXTO'"
                                        class="inline-block text-left font-medium border-1 surface-border bg-primary-100 text-primary-900 p-3 white-space-normal border-round"
                                        style="word-break: break-word; max-width:80%;">
                                        {{message.conteudo}}
                                    </span>

                                    <span *ngIf="message.tipoMensagem === 'IMAGEM'" class="cursor-pointer">
                                        
                                        <img class="w-12rem h-10rem" [src]="message.conteudo" alt=""
                                            (click)="baixarArquivoUrl(message.conteudo)">
                                    </span>

                                    <span *ngIf="message.tipoMensagem !== 'TEXTO' && message.tipoMensagem !== 'IMAGEM'"
                                        class="inline-block text-left font-medium border-1 surface-border text-primary-900
                                         p-3 white-space-normal border-round cursor-pointer hover:underline"
                                        style="word-break: break-word; max-width:80%;"
                                         (click)="baixarArquivoUrl(message.conteudo)" [pTooltip]="message.nomeArquivo ?? ''">
                                        <i [ngClass]="obterIconeArquivo(message.tipoMensagem)"
                                            class="mr-1"></i>{{message.nomeArquivo | slice:0:20}}
                                    </span>

                                    <p class="text-700 mt-3">{{ message.dataCriacao | date:'dd/MM/yyy HH:mm:ss' }}<i
                                            class="pi pi-check ml-2 text-green-400"></i></p>
                                </div>
                            </div>


                        </div>
                    </div>

                    <div class="pt-5 flex flex-column sm:flex-row
                     align-items-center mt-auto border-top-1 surface-border gap-3"
                        *ngIf="chamadoSelecionado.status === 'ABERTO'
                            || chamadoSelecionado.status === 'RECEBIDO'
                            || chamadoSelecionado.status === 'EM_ATENDIMENTO'">
                        <div class="flex flex-1 w-full sm:w-auto">

                            <button pButton pRipple icon="pi pi-images" class="p-button-outlined mr-2"
                                (click)="abrirDialogUpload()" pTooltip="Anexar arquivos"></button>
                            <input id="message" type="text" pInputText placeholder="Escreva a mensagem"
                                (focus)="rolarTelaBaixo()" class="flex-1 w-full sm:w-auto" [(ngModel)]="textContent"
                                (keydown.enter)="sendMessage()" />
                        </div>

                        <div class="flex w-full sm:w-auto gap-3">
                            <button class="p-button p-button-secondary w-full sm:w-auto justify-content-center text-xl"
                                (click)="op.toggle($event)">😀</button>
                            <button pButton label="Enviar" icon="pi pi-send" class="w-full sm:w-auto"
                                (click)="sendMessage()"></button>
                        </div>

                    </div>
                    <div *ngIf="chamadoSelecionado.status === 'ENCERRADO' ||
                     chamadoSelecionado.status === 'ENCERRADO_NAO_AVALIADO' ||
                     chamadoSelecionado.status === 'ENCERRADO_AVALIADO'" class="pt-5 flex flex-column sm:flex-row justify-content-center
                     align-items-center mt-auto border-top-1 surface-border gap-3">
                        <div class=" flex flex-column justify-content-center text-center">
                            <label class="text-xl mb-2" for="">Atendimento Encerrado</label>
                        </div>
                    </div>

                </div>

                <p-overlayPanel #op styleClass="w-full sm:w-30rem">
                    <ng-template pTemplate>
                        <button *ngFor="let emoji of emojis;" pButton pRipple (click)="op.hide(); onEmojiSelect(emoji)"
                            type="button" [label]="emoji" class="p-2 p-button-text text-2xl"></button>
                    </ng-template>
                </p-overlayPanel>


            </div>
        </div>
    </div>

</div>

<p-dialog #dialogUpload [(visible)]="mostrarDialogUpload" [breakpoints]="{'960px': '75vw', '640px': '90vw'}"
    [style]="{width: '50rem'}" [modal]="true" [closable]="true">
    <ng-template pTemplate="header">
        <span class="text-900 font-semibold text-xl">Anexar arquivos</span>
    </ng-template>

    <ng-template pTemplate="content">
        <div *ngIf="messagemVisivelDialog" class="w-full">
            <p-messages [(value)]="messagesDialog" [enableService]="false" [closable]="true"></p-messages>
        </div>
        <div class="flex flex-nowrap overflow-x-auto justify-start mt-4 gap-3 mb-3">

            <div *ngFor="let arquivo of arquivosAnexados; let i = index" class="relative w-8rem h-8rem">

                <img *ngIf="arquivo.preview" [src]="arquivo.preview" [pTooltip]="arquivo.nome"
                    class="object-cover w-full h-full rounded border-1 border-round border-gray-500" />
                <div *ngIf="arquivo.icone" [pTooltip]="arquivo.nome"
                    class="flex align-items-center justify-content-center w-full h-full border-1 border-round border-gray-500">
                    <i [ngClass]="arquivo.icone" class="text-4xl"></i>
                </div>
                <button pButton (click)="removerArquivo(i)" icon="pi pi-trash"
                    class="p-button-danger absolute top-0 right-0 mt-1 mr-1 w-2rem h-2rem">
                </button>
            </div>
        </div>


        <div class="border-2 border-dashed border-gray-300 rounded-lg p-4 text-center surface-100"
            (drop)="onDrop($event)" (dragover)="onDragOver($event)" (paste)="onPaste($event)">
            <i class="pi pi-upload text-4xl text-gray-500 mb-2 cursor-pointer" (click)="fileInput.click()"></i>
            <p class="text-gray-700 font-medium cursor-pointer" (click)="fileInput.click()">Arraste e solte arquivos
                aqui ou cole com Ctrl+V</p>
            <p class="text-sm text-gray-500">PNG, JPG, PDF, CSV, DOCX até 5MB</p>
        </div>

        <div class="mt-3 text-center">
            <button pButton type="button" [icon]="progressoSalvarAnexo ? 'pi pi-spin pi-spinner':'pi pi-check'"
                label="Anexar" (click)="salvarAnexos()" class="p-button-success"
                [disabled]="progressoSalvarAnexo || arquivosProcessando > 0 || arquivosAnexados.length < 1">
            </button>
            <input #fileInput type="file"
                accept="image/*,application/pdf,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/csv"
                multiple hidden (change)="onFileSelect($event)" />
        </div>
    </ng-template>
</p-dialog>

<p-dialog #dialogDetalheChamado [(visible)]="mostrarDialogDetalheChamado"
    [breakpoints]="{'960px': '75vw', '640px': '90vw'}" [style]="{width: '40rem'}" [modal]="true" [closable]="true">
    <ng-template pTemplate="header">
        <span class="text-900 font-semibold text-xl">Atendimento - {{chamadoSelecionado?.protocolo}}</span>
    </ng-template>

    <ng-template pTemplate="content">

        <div class="grid mt-1">
            <div class="col-12 md:col-6">
                <label class="label-superior">Situação</label>
                <label class="label-inferior">{{ chamadoSelecionado?.status }}</label>
            </div>
            <div class="col-12 md:col-6">
                <label class="label-superior">Abertura</label>
                <label class="label-inferior">{{ chamadoSelecionado?.dataCriacao | date:'dd/MM/yyyy HH:mm:ss' }}</label>
            </div>
            <div class="col-12 md:col-6">
                <label class="label-superior">Aberto por</label>
                <label class="label-inferior">{{ chamadoSelecionado?.usuarioAbertura?.apelido }}</label>
            </div>
            <div class="col-12 md:col-6" *ngIf="chamadoSelecionado?.status === 'ENCERRADO' ||
                chamadoSelecionado?.status === 'ENCERRADO_NAO_AVALIADO' ||
                chamadoSelecionado?.status === 'ENCERRADO_AVALIADO'">
                <label class="label-superior">Fechado por</label>
                <label class="label-inferior">{{ chamadoSelecionado?.usuarioFechamento?.apelido }}</label>
            </div>
            <div class="col-12 md:col-6">
                <label class="label-superior">Solicitado</label>
                <label class="label-inferior">{{ chamadoSelecionado?.solicitado }}</label>
            </div>
            <div class="col-12 md:col-6">
                <label class="label-superior">Tipo de chamado</label>
                <label class="label-inferior">{{ chamadoSelecionado?.tipo }}</label>
            </div>

            <div class="col-12">
                <p-divider></p-divider>
            </div>



            <div class="col-12 md:col-6">
                <label class="label-superior">Franquia</label>
                <label class="label-inferior">{{ chamadoSelecionado?.administradora?.nomeFantasia }}</label>
                <label class="label-inferior">{{ chamadoSelecionado?.administradora?.cnpj | cnpjCpfFormat }}</label>
            </div>

            <div class="col-12 md:col-6">
                <label class="label-superior">Empresa</label>
                <label class="label-inferior">{{ chamadoSelecionado?.empresa?.nomeFantasia }}</label>
                <label class="label-inferior">{{ chamadoSelecionado?.empresa?.cnpjCpf | cnpjCpfFormat }}</label>
            </div>
        </div>



    </ng-template>
</p-dialog>